// Splash screen shown while Auth0 is bootstrapping (mirrors SplashScreenComponent).
import { Box } from '@mui/material';

export function SplashScreen() {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        zIndex: (t) => t.zIndex.modal + 2,
      }}
    >
      <Box
        component="img"
        src="/assets/images/loader.gif"
        alt="Loading..."
        sx={{ maxWidth: 160 }}
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).style.display = 'none';
        }}
      />
    </Box>
  );
}
